import { UpdateDoctorRegisterStatus } from 'domain/usecases/doctor-register/update-doctor-register-status'
import { DoctorRepository } from '../../../repository/interfaces/doctor-repository'

export class RemoteUpdateDoctorRegisterStatus
  implements UpdateDoctorRegisterStatus
{
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }

  execute(
    params: UpdateDoctorRegisterStatus.Params
  ): Promise<UpdateDoctorRegisterStatus.Model> {
    return this.doctorRepository.updateDoctorRegisterStatus(params)
  }
}
